import { render, staticRenderFns } from "./CompNewsContainer.vue?vue&type=template&id=43466a3e&scoped=true"
import script from "./CompNewsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./CompNewsContainer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43466a3e",
  null
  
)

export default component.exports